<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card card-top-line">
          <div class="header">
            <h2>Manage Multisave Discount</h2>
          </div>
          <div class="body pt-0">
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <b-table
              ref="partnertable"
              responsive
              hover
              table-class="js-basic-example table-custom mb-0 border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              striped
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(actions)>
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  right
                  variant="outline-primary"
                >
                  <b-dropdown-item @click="$bvModal.show('edit-discount')">
                    Edit
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <b-modal
              id="edit-discount"
              size="md"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Edit Discount
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form @submit.prevent="passes(UpdateSubmit)">
                    <ValidationProvider
                      name="discount_rate"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !discount_rate,
                          success: discount_rate,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="discount_rate"
                            @keypress="onlyNumber($event)"
                            class="form-control"
                          />
                          <label for="discount_rate" class="control-label">
                            Flat Percentage Discount for Single Transaction*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !discount_rate"
                          ></i>
                          <i class="fa fa-check" v-if="discount_rate"></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="$bvModal.hide('edit-discount')"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                        @click="isDisplayPhoneError = true"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
const { ValidationObserver, ValidationProvider } = require("vee-validate");
export default {
  name: "ManageMultisaveDiscount",
  components: {
    BreadCrumb,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      discount_rate: 15,
      items: [
        {
          sl_no: 1,
          discount_type: "Flat Percentage Discount for Single Transaction",
          discount_rate: 15,
        },
        {
          sl_no: 2,
          discount_type: "Total Checkout Amount method for Multi Transaction",
          discount_rate: 2,
        },
        {
          sl_no: 2,
          discount_type: "Flat Percentage Discount for Multi Transaction	",
          discount_rate: 0,
        },
        {
          sl_no: 4,
          discount_type: "Transaction Ranking for Multi Transaction",
          discount_rate: 5,
        },
      ],
      fields: [
        { key: "sl_no", label: "Sl No", sortable: true, thClass: "th_sortfix" },
        {
          key: "discount_type",
          label: "Discount Type",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "discount_rate",
          label: "Discount Rate(%)",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "actions",
          label: "Actions",
          thClass: "th_sortfix text-right pr-4",
          tdClass: "text-right",
        },
      ],

      totalRows: 0,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, { value: 100, text: 100 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
    };
  },
  methods: {
    UpdateSubmit() {
      console.log(this.discount_rate);
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
  },
  mounted() {
    this.totalRows = this.items.length;
  },
};
</script>
